import { render, staticRenderFns } from "./EventForm.vue?vue&type=template&id=fab220e8&"
import script from "./EventForm.vue?vue&type=script&lang=js&"
export * from "./EventForm.vue?vue&type=script&lang=js&"
import style0 from "./EventForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/T7/BACKUP/repositories/reveil-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fab220e8')) {
      api.createRecord('fab220e8', component.options)
    } else {
      api.reload('fab220e8', component.options)
    }
    module.hot.accept("./EventForm.vue?vue&type=template&id=fab220e8&", function () {
      api.rerender('fab220e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/EventForm.vue"
export default component.exports